import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DataStateChangeEvent, GridComponent, SelectAllCheckboxState } from '@progress/kendo-angular-grid';
import { process } from '@progress/kendo-data-query';
import { DafService } from 'src/app/DAF/services/dafService';
import { Router, ActivatedRoute } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { EympService } from 'src/app/eymp-notices/services/eympservice';
import { DatePipe } from '@angular/common';
import { ExportParams, PagingParams } from '../Model/filterparams';
import * as fileSaver from 'file-saver';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-dashboard-details',
  templateUrl: './dashboard-details.component.html',
  styleUrls: ['./dashboard-details.component.scss']
})
export class DashboardDetailsComponent implements OnInit {

  public pageSize = 10;
  public skip = 0;
  public isPageReady = false;
  public caseList: any;
  public caseFormList: any;
  public gridViewData: any[];
  public Status = "";
  public NoticesStatus = "";
  gridFilteredData: any;
  private notifier: NotifierService;
  public selecteddocumentId = 0;

  public gridState: DataStateChangeEvent = {

    skip: this.skip,
    take: this.pageSize
  };
  dateFilterModel: DateFiltersModel;
  fromreportDate: any;
  toreportDate: any

  constructor(public _dafService: DafService, private router: Router, private route: ActivatedRoute, notifier: NotifierService, public _eympservice: EympService, public datepipe: DatePipe) {
    this.dateFilterModel = new DateFiltersModel(new Date(), new Date());
    this.notifier = notifier;
  }
  take: number;
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.NoticesStatus = params['NoticeStatus'];
      this.Status = params['Status'];
    });
    this._dafService.currentInsDates.subscribe(data => {
      this.fromreportDate = data.fromDate;
      this.toreportDate = data.toDate;
      this.dateFilterModel = new DateFiltersModel(new Date(this.fromreportDate), new Date(this.toreportDate));
      this.refreshCaseList(this.gridState);
    });
    this.refreshCaseList(this.gridState);
  }

  onSave(action: string) {
    if (action === 'refresh') {
      this.filterCaseList(); // Refresh the grid data
    }
  }

  filterCaseList() {

    this._dafService.updateINSDate({ fromDate: this.dateFilterModel.startDate.toDateString(), toDate: this.dateFilterModel.endDate.toDateString() });
  }
  resetDashboard() {
    this._dafService.resetDate.subscribe(data => {
      this._dafService.updateINSDate({ fromDate: data, toDate: data });
    });
  }


  refreshCaseList(state: DataStateChangeEvent) {

    this.isPageReady = false;
    var kets = state;
    this.gridState = kets;
    let skip = 0;
    if (state.skip !== 0) {
      skip = state.skip / 10;
    }
    var summaryParams = new ExportParams();
    summaryParams.PagingParams = new PagingParams();
    summaryParams.PagingParams.PageNumber = skip + 1;
    summaryParams.PagingParams.PageSize = state.take;
    if (state.filter != null) {
      summaryParams.FilterParams = state.filter.filters;
    }
    else {
      summaryParams.FilterParams = null;
    }
    this._eympservice.getEympNoticesDetailsWithStatus(this.Status, this.dateFilterModel.startDate.toDateString(), this.dateFilterModel.endDate.toDateString(), 'G', summaryParams).subscribe((data: any) => {
      this.gridFilteredData = data;
      // Binds the data to grid
      let dataParams = process(this.gridFilteredData.caseNoticesSummaryModel, { skip: 0, take: this.pageSize, filter: this.gridState.filter, sort: this.gridState.sort }).data;
      this.caseList = { data: dataParams, total: this.gridFilteredData.totalRowCount };
      this.isPageReady = true;

    },
      (error) => {
        this.isPageReady = true;
        //this.notifier.notify('error', 'Error occured while getting data from server');
      }
    );
  }
  private rowCallback(row: any) {
    const isEven = row.index % 2 == 0;
    return {
      even: isEven,
      odd: !isEven
    };
  }

}

export class DateFiltersModel {
  public startDate: Date;
  public endDate: Date;
  constructor(startDate: Date, endDate: Date) {
    this.startDate = startDate;
    this.endDate = endDate;
  }
}
